import React from "react";
import CommonModal from "../../Settings/components/ResetContext/components/DumpModal";
import { Button } from "@mui/material";

const PermissionRequiredModal = ({ isOpen, onClose }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <p className="text-left text-[18px] font-bold">Permission Required</p>
      }
      showAlert={false}
    >
      <p className="text-[#64748B] mb-4 text-[14px]">
        You don't have permission to build a custom agent. Speak to an admin.
      </p>
      <div className="w-full flex items-center justify-end">
        <Button
          onClick={onClose}
          sx={{ border: "1px solid #E2E8F0", color: "#000" }}
        >
          Close
        </Button>
      </div>
    </CommonModal>
  );
};

export default PermissionRequiredModal;
